<label class="questionLabel" [attr.for]="question.key">{{question.label}}</label>
<input class="form-control questionTag input-field-focus" [formControl]="control"
       [id]="question.key" [type]="question.type" (change)="executeParentFunction($event)"/>
